import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import 'bootstrap/dist/css/bootstrap.min.css';
import './CategoryPage.css';
import niepvd from '../../assets/niepvd.png';
import nab from '../../assets/nab.png';
import bpa from '../../assets/BPA.png';
import dis from '../../assets/disability-img.png';
import books from '../../assets/books.png';
import { REACT_APP_SHRAVAN_BASE_URL } from "../../utils/constants";

function CategoryPage(props) {


  const [categories, setCategories] = useState([]);
  // const [selectedLanguage, setSelectedLanguage] = useState(props.selectedLanguage);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const navigate = useNavigate();

  // Fetch categories on component mount
  useEffect(() => {
    localStorage.setItem('currentLanguage', props.selectedLanguage);
    navigate(`/category/${props.selectedLanguage}/books`);

    const fetchCategories = async () => {
      try {
        setLoading(true);
        const response = await axios.get(`${REACT_APP_SHRAVAN_BASE_URL}/categories/English`, {
          headers: {
            'Content-Type': 'application/json'
          }
        });
        const data = response.data;
        setCategories(data);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchCategories();
  }, []);

  const handleCategoryClick = (category) => {
    localStorage.setItem('currentCategory', category);
  };

  const handleLanguageChange = async (event) => {
    const lang = event.target.value;
    props.setSelectedLanguage(lang);
    localStorage.setItem('currentLanguage', lang);
  };

  return (
    <div className="component-container">
        <div className='container card-container' style={{ padding: '20px', textAlign: 'center',width:'100%' }}>
      {/* <h1 className="text-center">Welcome to Shravan Audiobooks Library</h1> */}

      <div className='d-flex flex-column justify-content-center align-items-start category-container w-100'>

        {/* <div className='d-flex flex-row flex-wrap justify-content-end align-items-center w-100'>
          <h2 className='me-3 my-auto text-left language-font'>Select a language</h2>
          <select className='form-select w-auto' value={selectedLanguage} onChange={handleLanguageChange}>
            <option key='hindi' value='Hindi'>
              Hindi
            </option>
            <option key='english' value='English'>
              English
            </option>
          </select>
        </div> */}

        <div className='d-flex flex-row flex-wrap justify-content-between align-items-center w-100'>
          {/* <h2 className='me-3 text-left'>Choose one category</h2> */}
          <div className='category-list w-100'>
            <div key='cat-1' className='category-item'>
              <img src={niepvd} alt='NIEPVD'/>
              <Link
                to={`/category/${props.selectedLanguage}/other/${categories[0]}`}
                onClick={() => { handleCategoryClick(categories[0]) }}
                style={{ textDecoration: 'none', color: 'inherit' }}
              >
                <div className="result-data d-flex justify-content-start align-items-baseline">
                  <p className='mb-0'>1. {categories[0]}</p>
                </div>
              </Link>
            </div>

            <div key='cat-2' className=' category-item'>
            <img src={nab} alt='NAB delhi'/>
              <Link
                to={`/category/${props.selectedLanguage}/other/${categories[1]}`}
                onClick={() => { handleCategoryClick(categories[1]) }}
                style={{ textDecoration: 'none', color: 'inherit' }}
              >
                <div className="result-data d-flex justify-content-start align-items-baseline">
                  <p className='mb-0'>2. {categories[1]}</p>
                </div>
              </Link>
            </div>

            <div key='cat-3' className=' category-item'>
            <img src={bpa} alt='Blind peoples association'/>
              <Link
                to={`/category/${props.selectedLanguage}/other/${categories[2]}`}
                onClick={() => { handleCategoryClick(categories[2]) }}
                style={{ textDecoration: 'none', color: 'inherit' }}
              >
                <div className="result-data d-flex justify-content-start align-items-baseline">
                  <p className='mb-0'>3. {categories[2]}</p>
                </div>
              </Link>
            </div>

            <div key='cat-4' className=' category-item'>
            <img src={dis} alt='disability information'/>
              <Link
                to={`/category/${props.selectedLanguage}/other/${categories[3]}`}
                onClick={() => { handleCategoryClick(categories[3]) }}
                style={{ textDecoration: 'none', color: 'inherit' }}
              >
                <div className="result-data d-flex justify-content-start align-items-baseline">
                  <p className='mb-0'>4. {categories[3]}</p>
                </div>
              </Link>
            </div>

            {/* <div key='cat-4' className=' category-item'>
              <Link
                to={`/category/${selectedLanguage}/other/${categories[4]}`}
                onClick={() => { handleCategoryClick(categories[4]) }}
                style={{ textDecoration: 'none', color: 'inherit' }}
              >
                <div className="result-data d-flex justify-content-start align-items-baseline">
                  <p className='mb-0'>5. {categories[4]}</p>
                </div>
              </Link>
            </div> */}

            <div key='cat-5' className=' category-item'>
            <img src={books} alt='books'/>
              <Link
                to={`/category/${props.selectedLanguage}/books`}
                onClick={() => { handleCategoryClick('books') }}
                style={{ textDecoration: 'none', color: 'inherit' }}
              >
                <div className="result-data d-flex justify-content-start align-items-baseline">
                  <p className='mb-0'>5. Books</p>
                </div>
              </Link>
            </div>
          </div>
        </div>
        {loading && <p>Loading books...</p>}
        {error && <p style={{ color: 'red' }}>Error: {error}</p>}
      </div>
    </div>
    </div>
  );
}

export default CategoryPage;
